import React, { useMemo, useRef } from 'react'
import classNames from 'classnames'
import { MessageWrapper } from './MessageWrapper'
import { MessageSwitchProps } from '../MessageSwitch'
import emojiToImg from '~/utils/emojiToImg'
import { useNarrow } from '~/utils/useNarrow'
import { MessageClient } from '~/service/chatConn/types'
import { useEmojiOnly } from '~/utils/hooks'
import { escapeHtml } from '~/utils/string'

type QuestionProps = MessageSwitchProps<MessageClient>

const Question: React.FC<QuestionProps> = ({ ...props }) => {
  const { message } = props
  const emojiOnly = useEmojiOnly(message.content)

  // ten escape był, bo wcześniej w chatConverter był decodeHtml
  // ale nie wiem dlaczego
  // const text = useMemo(() => emojiToImg(escapeHtml(message.content)), [])
  const text = useMemo(() => emojiToImg(message.content), [])

  const ref = useRef<HTMLDivElement>(null)

  if (!message.form) {
    useNarrow(ref, props.parentWidth)
  }

  return (
    <MessageWrapper
      className={classNames('is-question', { 'is-emojiOnly': emojiOnly })}
      _ref={ref}
      {...props}
    >
      {message.form ? (
        <table className="table">
          <tbody>
            {message.form.map((row, i) => (
              <tr key={i}>
                <th>{row.name}</th>
                <td>{row.value}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <span dangerouslySetInnerHTML={{ __html: text }} />
      )}

      <svg aria-hidden="true">
        <rect x="0" />
      </svg>
    </MessageWrapper>
  )
}

export default Question
